import { oneOf } from 'prop-types';
import React from 'react';

import styles from './IconBedRoom.module.scss';

export const COLORS = {
  DARK_PINK: '#8F4E6D',
  BLACK: '#525252',
};

export const SIZES = {
  SMALL: 'small',
  LARGE: 'large',
};

const IconBedRoom = ({ color, size }) => {
  return (
    <svg
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles[size]}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.42778 12.7397C3.42778 14.1888 4.51818 15.3622 5.86218 15.3622C7.20778 15.3622 8.29738 14.1888 8.29738 12.7397C8.29738 11.2915 7.20778 10.118 5.86218 10.118C4.51818 10.118 3.42778 11.2915 3.42778 12.7397Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.48006 10.118V20.6064"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8801 12.7396V20.6063"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="-1"
        width="24"
        height="23"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 21.1228H24.36V-0.000366211H1V21.1228Z"
          fill="white"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.48 18.5073H23.88V15.3618H1.48V18.5073Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2453 15.3622H21.9317C21.9317 14.1294 21.1533 13.0542 20.0429 12.7561L13.8757 11.0959C12.3109 10.6746 10.7245 11.699 10.3325 13.3841C10.2749 13.6348 10.2453 13.8907 10.2453 14.1492V15.3622Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0106 10.7054V5.76099"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3379 5.76115H16.6827C16.4139 5.76115 16.1955 5.52681 16.1955 5.23648C16.1955 5.20201 16.1995 5.16669 16.2051 5.13223L16.9851 0.936537C17.0315 0.692722 17.2307 0.516968 17.4619 0.516968H20.5587C20.7907 0.516968 20.9899 0.692722 21.0363 0.936537L21.8155 5.13223C21.8691 5.41568 21.6987 5.69223 21.4355 5.75081C21.4035 5.75771 21.3707 5.76115 21.3379 5.76115Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9583 5.76111V6.99742"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconBedRoom.propTypes = {
  color: oneOf(Object.values(COLORS)),
  size: oneOf(Object.values(SIZES)),
};

IconBedRoom.defaultProps = {
  color: COLORS.BLACK,
  size: SIZES.SMALL,
};

export default IconBedRoom;
